<template>
  <div class="overlay" role="dialog" aria-modal="true" aria-labelledby="titulo-modal-formulario"
    @click.self="fecharModal">
    <div class="modal-container">
      <header class="modal-header">
        <span class="modal-label">escolha o tipo de formulário</span>

        <button type="button" class="btn-fechar-modal" aria-label="Fechar modal" title="Fechar" @click="fecharModal">
          ×
        </button>
      </header>


      <div class="modal-corpo">
        <div class="modal-introducao">
          <div class="modal-texto-introducao">
            <h4>
              Qual formulário de parceria você deseja preencher?
            </h4>

            <p>
              Selecione uma das opções abaixo para continuar.
            </p>
          </div>
        </div>


        <div class="modal-opcoes">
          <button type="button" class="opcao-formulario" @click="acessarFormularioExterno">
            <div class="opcao-icone externa">
              <i class="fa-solid fa-building" aria-hidden="true"></i>
            </div>

            <div class="opcao-conteudo">
              <div class="opcao-formulario-titulo">
                <strong>
                  Parceria Externa
                </strong>

                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </div>

              <span>
                Para estabelecer parceria com entidades externas à UFC,
                como órgãos públicos, escolas, ONGs/OSCs ou empresas.
              </span>


            </div>
          </button>

          <button type="button" class="opcao-formulario" @click="acessarFormularioInterno">
            <div class="opcao-icone interna">
              <i class="fa-solid fa-building-columns" aria-hidden="true"></i>
            </div>

            <div class="opcao-conteudo">
              <div class="opcao-formulario-titulo">
                <strong>
                  Parceria Interna (Intra Muros)
                </strong>

                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </div>

              <span>
                Para articular parceria com outra unidade, centro,
                instituto ou campus da própria UFC.
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits([
  "fecharModal",
  "formularioExterno",
  "formularioInterno",
]);

function fecharModal() {
  emit("fecharModal");
}

function acessarFormularioExterno() {
  emit("formularioExterno");
}

function acessarFormularioInterno() {
  emit("formularioInterno");
}
</script>

<style scoped>
.modal-container {
  width: 500px;


  border-radius: 12px;

  overflow: hidden;


}



.modal-corpo {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: var(--branco);

}

.modal-introducao {
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  gap: 12px;
}


.modal-texto-introducao {
  display: flex;
  flex-direction: column;
}

.modal-texto-introducao h4 {
  margin: 0;

  color: var(--preto);

  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}

.modal-texto-introducao p {
  margin: 0;

  color: var(--cinza-escuro);

  font-size: 13px;
  line-height: 1.5;
}

.modal-opcoes {
  width: 100%;

  display: flex;
  flex-direction: column;

  gap: 12px;
}

.opcao-formulario {
  width: 100%;

  padding: 16px;

  display: flex;
  align-items: flex-start;

  gap: 14px;

  border: 1px solid var(--roxo-superficie);
  border-radius: 10px;

  background: var(--branco);
  color: var(--cinza-escuro);

  text-align: left;

  cursor: pointer;


}

.opcao-formulario:hover {
  background: var(--roxo-primario);
  color: var(--branco);
}

.opcao-formulario:hover span {
  color: var(--branco);
}

.opcao-formulario:hover strong {
  color: var(--branco);
}

.opcao-formulario:hover i {
  color: var(--branco);
}

.opcao-formulario:hover .fa-building {
  color: var(--roxo-primario);
}

.opcao-formulario:hover .fa-building-columns {
  color: var(--roxo-primario);
}

.opcao-icone {
  width: 42px;
  height: 42px;

  min-width: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
}

.opcao-icone i {
  font-size: 17px;
}

.opcao-conteudo {
  min-width: 0;

  flex: 1;

  display: flex;
  flex-direction: column;

  gap: 6px;
}

.opcao-formulario-titulo {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 12px;
}

.opcao-formulario-titulo strong {
  color: var(--roxo-primario);

  font-size: 14px;
  font-weight: 700;

  line-height: 1.4;
}

.opcao-formulario-titulo>i {
  flex-shrink: 0;

  color: var(--roxo-claro);

  font-size: 12px;

  transition: transform 0.15s ease;
}



.opcao-formulario span {
  display: block;

  margin: 0;

  color: var(--cinza-escuro);

  font-size: 12.5px;

  line-height: 1.5;
}

.opcao-formulario small {
  display: flex;
  align-items: center;

  gap: 5px;

  margin-top: 2px;

  color: var(--cinza-escuro);

  font-size: 11px;
  font-weight: 600;
}

.opcao-formulario small i {
  color: var(--roxo-claro);

  font-size: 10px;
}


@media (max-width: 600px) {
  .modal-overlay {
    padding: 14px;
  }

  .modal-container {
    width: 100%;
    border-radius: 10px;
  }

  .modal-header {
    min-height: 48px;
  }

  .btn-fechar-modal {
    width: 48px;
    height: 48px;
  }

  .modal-content {
    padding: 24px 16px 18px;

    gap: 20px;
  }

  .modal-icone {
    width: 52px;
    height: 52px;
  }

  .modal-texto-introducao h4 {
    font-size: 15px;
  }

  .modal-texto-introducao p {
    font-size: 12px;
  }

  .opcao-formulario {
    padding: 14px;
  }

  .opcao-icone {
    width: 38px;
    height: 38px;
    min-width: 38px;
  }

  .opcao-icone i {
    font-size: 15px;
  }

  .opcao-formulario-titulo strong {
    font-size: 13px;
  }

  .opcao-formulario span {
    font-size: 12px;
  }

  .opcao-formulario small {
    font-size: 10px;
  }
}

@media (max-width: 380px) {
  .opcao-formulario {
    gap: 10px;
    padding: 12px;
  }

  .opcao-icone {
    display: none;
  }

  .opcao-formulario-titulo {
    gap: 8px;
  }
}
</style>